import { defineMessages } from '@jutro/locale';

export default defineMessages({
    NoDocumentsAvailable: {
        id: 'ml.common.ml-document-table.No documents are available for this category',
        defaultMessage: 'No documents are available for this category'
    },
    Date: {
        id: 'ml.common.ml-document-table.Date',
        defaultMessage: 'Date'
    },
    Document: {
        id: 'ml.common.ml-document-table.Document',
        defaultMessage: 'Document'
    },
    Type: {
        id: 'ml.common.ml-document-table.Type',
        defaultMessage: 'Type'
    },
    Actions: {
        id: 'ml.common.ml-document-table.Actions',
        defaultMessage: 'Actions'
    },
    NEW: {
        id: 'ml.common.ml-document-table.NEW',
        defaultMessage: 'NEW'
    },
    ActionRequired: {
        id: 'ml.common.ml-document-table.Action Required',
        defaultMessage: 'Action Required'
    },
    ViewPrint: {
        id: 'ml.common.ml-document-table.View / Print',
        defaultMessage: 'View / Print'
    },
    Generating: {
        id: 'ml.common.ml-document-table.Generating...',
        defaultMessage: 'Generating...'
    }
});
